export default "__VITE_ASSET__DHs5NLMe__"